import { render, staticRenderFns } from "./questionTypeDob.vue?vue&type=template&id=8391b756&scoped=true&"
import script from "./questionTypeDob.vue?vue&type=script&lang=js&"
export * from "./questionTypeDob.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeDob.vue?vue&type=style&index=0&id=8391b756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8391b756",
  null
  
)

export default component.exports